var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "class-page assignment-bin-page" },
    [
      _c("ClassPageHeader", {
        attrs: {
          details: _vm.details,
          "current-section": parseInt(_vm.sectionId),
          course: _vm.course,
          menu: _vm.menu,
          "is-class-item-page": true,
          "course-content": _vm.courseContent
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "assignment-bin" },
        [
          _c("div", { staticClass: "back-link" }, [
            _c(
              "a",
              {
                staticStyle: { cursor: "pointer" },
                on: {
                  click: function($event) {
                    return _vm.$router.go(-1)
                  }
                }
              },
              [
                _c("i", {
                  staticClass: "fas fa-caret-left",
                  attrs: { "aria-hidden": "true" }
                }),
                _vm._v(
                  _vm._s(_vm.$t("MAIN_CONTENT.commonContent.goBack")) +
                    "\n\t\t\t"
                )
              ]
            )
          ]),
          _vm._v(" "),
          _vm.dataBin.length > 0
            ? _vm._l(_vm.dataBin, function(assignment, assignmentIndex) {
                return _c(
                  "div",
                  {
                    key:
                      "displayTable_" +
                      assignment.ASSIGNMENT_CODE +
                      "_index_" +
                      assignmentIndex,
                    staticClass: "display-table"
                  },
                  [
                    _c("div", { staticClass: "display-container" }, [
                      _c("div", { staticClass: "header color-status" }, [
                        _c(
                          "div",
                          {
                            class:
                              "pill float-left " +
                              _vm.dueSoon(assignment.ASSIGNMENT_END_DATE)
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t" +
                                _vm._s(
                                  _vm.$t("MAIN_CONTENT.AssignmentBin.due", {
                                    date: _vm.dateFormat(
                                      assignment.ASSIGNMENT_END_DATE
                                    )
                                  })
                                ) +
                                "\n\t\t\t\t\t\t"
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "score-pill float-right" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t" +
                              _vm._s(
                                _vm.$t("MAIN_CONTENT.commonContent.score")
                              ) +
                              " \n\t\t\t\t\t\t\t"
                          ),
                          !!assignment.DETAILS.MAX_POINTS
                            ? _c("strong", [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.$t(
                                        "MAIN_CONTENT.AssignmentBin.gradeOverPoints",
                                        {
                                          grade: assignment.DETAILS.GRADE_CODE,
                                          points: assignment.DETAILS.MAX_POINTS
                                        }
                                      )
                                    ) +
                                    "\n\t\t\t\t\t\t\t"
                                )
                              ])
                            : _c("strong", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("MAIN_CONTENT.AssignmentBin.hyphen")
                                  )
                                )
                              ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "sub-header" }, [
                        _c("div", [
                          _c(
                            "a",
                            {
                              staticStyle: { cursor: "pointer" },
                              on: {
                                click: function($event) {
                                  return _vm.goToSubmissions(assignment)
                                }
                              }
                            },
                            [
                              _c("h2", [
                                _vm._v(_vm._s(assignment.ASSIGNMENT_NAME))
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "float-right" }, [
                            _c(
                              "a",
                              {
                                staticStyle: { cursor: "pointer" },
                                on: {
                                  click: function($event) {
                                    return _vm.goToSubmissions(assignment)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.$t(
                                        "MAIN_CONTENT.AssignmentBin.mySubmissions"
                                      )
                                    ) +
                                    " \n\t\t\t\t\t\t\t\t\t"
                                ),
                                _c(
                                  "span",
                                  { staticClass: "pill pill-submissions" },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t\t\t" +
                                        _vm._s(assignment.SUBMISSIONS.length) +
                                        "\n\t\t\t\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              ]
                            )
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "attached" },
                        [
                          _c("h3", [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t" +
                                _vm._s(
                                  _vm.$t(
                                    "MAIN_CONTENT.AssignmentBin.attachedFiles"
                                  )
                                ) +
                                " \n\t\t\t\t\t\t\t"
                            ),
                            _c("span", { staticClass: "pill pill-attached" }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t" +
                                  _vm._s(assignment.ATTACHMENTS.length) +
                                  "\n\t\t\t\t\t\t\t"
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _vm._l(assignment.ATTACHMENTS, function(
                            attached,
                            attachedIndex
                          ) {
                            return _c(
                              "div",
                              {
                                key:
                                  "attachments_" +
                                  attached.REPORT_ID +
                                  "_assignment_" +
                                  assignmentIndex +
                                  "_index_" +
                                  attachedIndex,
                                staticClass: "attached-file"
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: attached.ATTACHMENT_URL,
                                      target: "_blank"
                                    }
                                  },
                                  [
                                    _c("i", {
                                      class:
                                        "fas " +
                                        _vm.fileType(attached.CONTENT_ID),
                                      attrs: { "aria-hidden": "true" }
                                    }),
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(attached.CONTENT_FILENAME) +
                                        "\n\t\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              ]
                            )
                          })
                        ],
                        2
                      ),
                      _vm._v(" "),
                      !!assignment.FEEDBACK.FEEDBACK_TEXT
                        ? _c("div", { staticClass: "feedback" }, [
                            _c(
                              "a",
                              {
                                staticClass: "btn btn-feedback",
                                staticStyle: { cursor: "pointer" },
                                on: {
                                  click: function($event) {
                                    return _vm.goToFeedback(assignment)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.$t(
                                        "MAIN_CONTENT.AssignmentBin.seeFeedback"
                                      )
                                    ) +
                                    "\n\t\t\t\t\t\t"
                                )
                              ]
                            )
                          ])
                        : _vm._e()
                    ])
                  ]
                )
              })
            : [
                _c("div", { staticClass: "alert alert-info" }, [
                  _vm._v(
                    "\n\t\t\t\t" +
                      _vm._s(
                        _vm.$t(
                          "MAIN_CONTENT.AssignmentBin.noAssignmentsInAssignmentBin"
                        )
                      ) +
                      "\n\t\t\t"
                  )
                ])
              ]
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }